import React, { useEffect, useState } from "react";
import { Formik, Field, Form } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { Box, FormGroup, Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import AppInput from "components/Input/AppInput";
import AppButton from "components/CustomButtons/AppButton";
import { YupValidations } from "utils/validate";
import { useHistory, useParams } from "react-router";

import { useDispatch, useSelector } from "react-redux";
import classNames from "classnames";
import AppColor from "utilities/AppColor";

import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import AppCheckbox from "components/Input/AppCheckbox";
import AppConfig from "config/AppConfig";
import { reducePurchaseSubscription } from "store/slices/subscription";
import { getMe } from "store/slices/auth";
import { fetchListSubscription } from "store/slices/subscription";

import CardInformationForm from "./CardInformationForm";
import { showToast } from "store/slices/toast";
import { getAuthInfo } from "store/slices/auth";
import moment from "moment";

const { PATTERNS } = AppConfig;
const stripePromise = loadStripe(
  `${process.env.REACT_APP_CLIENT_STRIPE}`
);
// import unknowCardIcon from "../../../../assets/img/unknown_card_icon.png";

const useStyles = makeStyles(() => ({
  control: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "center",
    marginTop: "1rem",
  },
  title: {
    display: "flex",
    margin: "2rem 0 0 0",
    "& h5": {
      color: AppColor.black,
    },
  },
  listCard: {
    display: "flex",
    justifyContent: "center",
  },
  box: {
    boxShadow:
      "0px 4px 4px rgba(0, 0, 0, 0.15), inset 0px 4px 4px rgba(0, 0, 0, 0.15)",
    borderRadius: "20px",
    marginBottom: "20px",
    padding: "10px",
    marginTop: '20px'
  },
  boxHead: {
    boxShadow:
      "0px 4px 4px rgba(0, 0, 0, 0.15), inset 0px 4px 4px rgba(0, 0, 0, 0.15)",
    borderRadius: "20px",
    marginBottom: "20px",
    padding: "10px"
  },
  link: {
    color: "#277BC9",
    cursor: "pointer",
  },
}));

const SubscriptionDetail = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { id: subscriptionId } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  const [subscriptionDetail, setSubscriptionDetail] = useState({});
  // const { pricing } = subscriptionDetail;

  const [isLoading, setIsLoading] = useState(false);
  const [isOpenEdit, setOpenEdit] = useState(false);

  const authInfo = useSelector(getAuthInfo);

  useEffect(() => {
    if (authInfo && authInfo.companySubscriptionId &&  authInfo.companySubcriptionExpiryDate && subscriptionId && parseInt(authInfo.companySubscriptionId) === parseInt(subscriptionId)) {
      const _expiredDate = moment(authInfo.companySubcriptionExpiryDate);
        const currentDate = moment();
      if (_expiredDate.diff(currentDate) > 0) {
        dispatch(showToast({
          type: "danger",
          message: t(`toast.error.subscription_is_purchased`)
        }));
        history.push('/admin/subscriptions')
      }
    }
  }, [subscriptionId]);

  const validationSchema = Yup.object().shape({
    firstName: YupValidations.requiredString,
    lastName: YupValidations.requiredString,
    email: Yup.string()
      .trim()
      .required("validation.email.required")
      .email("validation.email.invalid")
      .max(255, { message: "validation.max_length", value: 255 })
      .matches(PATTERNS.BLANK_SPACES, "validation.blankSpaces"),
  });

  const submit = async (data) => {
    setIsLoading(true);
    const { payload } = await dispatch(
      reducePurchaseSubscription({
        subscriptionId: subscriptionId,
        firstName: data.firstName,
        lastName: data.lastName,
        email: data.email.trim(),
      })
    );
    if (payload) {
      history.push("/admin/subscriptions");
      await dispatch(getMe());
    } else {
      history.push("/admin/subscriptions");
    }
    setIsLoading(false);
  };
  const _loadSubscriptionInfo = async () => {
    const { payload } = await dispatch(
      fetchListSubscription({ recurring: "" })
    );
    if (payload) {
      const subsInfo = payload.filter(
        (item) => item.id === parseInt(subscriptionId)
      );
      if (subsInfo[0]) {
        setSubscriptionDetail(subsInfo[0]);
      } else {
        history.push("/admin/subscriptions");
        dispatch(showToast({type: "danger",
        message: t(`toast.error.subscription_not_found`),}))
      }
    }
  };

  useEffect(() => {
    _loadSubscriptionInfo();
  }, []);

  return (
    <Box style={{padding: '20px'}}>
      <Formik
        initialValues={{
          firstName: "",
          lastName: "",
          email: "",
        }}
        validationSchema={validationSchema}
        onSubmit={submit}
        enableReinitialize
      >
        {({ values, handleSubmit }) => (
          <Form>
            <Grid container spacing={3} className={classes.boxHead}>
              <Grid item xs={12} md={12}>
                <Box
                  className={classNames({
                    [classes.title]: true,
                    "mt-0": true,
                  })}
                >
                  <Typography variant="h5">
                    {t("title.billing_information")}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <Field
                  component={AppInput}
                  name="firstName"
                  label={"label.firstName"}
                  required
                  // disabled={true}
                />
                <Field
                  component={AppInput}
                  name="lastName"
                  label={"label.lastName"}
                  // disabled={true}
                  required
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Field
                  component={AppInput}
                  name="email"
                  label={"label.email"}
                  // disabled={true}
                  required
                />
              </Grid>
            </Grid>
            {/* card info */}
            <CardInformationForm setOpenEdit={setOpenEdit} isOpenEdit={isOpenEdit}/>
            {/* order summary */}
            <Grid container spacing={3} className={classes.box}>
              <Grid item xs={12} md={12}>
                <Box
                  className={classNames({
                    [classes.title]: true,
                    "mt-0": true,
                  })}
                >
                  <Typography variant="h5">
                    {t("title.order_summary")}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} md={12}>
                <Box>
                  <Grid container>
                    <Grid item xs={8}>
                      <Typography
                        style={{
                          fontWeight: "500",
                          fontSize: 18,
                          wordBreak: "break-all",
                        }}
                      >
                        {subscriptionDetail.packageName}
                      </Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography
                        style={{
                          fontWeight: "500",
                          fontSize: 18,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-end",
                        }}
                      >{`$${subscriptionDetail.pricing}`}</Typography>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
            {/* subtotal */}
            <Grid container spacing={3} className={classes.box}>
              <Grid item xs={12} md={12}>
                <Box
                  className={classNames({
                    [classes.title]: true,
                    "mt-0": true,
                  })}
                >
                  <Typography variant="h5">{t("title.sub_total")}</Typography>
                </Box>
              </Grid>
              <Grid item xs={12} md={12}>
                <Box
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Typography style={{ fontWeight: "500", fontSize: 18 }}>
                    {t("label.order_total")}
                  </Typography>
                  <Typography
                    style={{ fontWeight: "500", fontSize: 18 }}
                  >{`$${subscriptionDetail.pricing}`}</Typography>
                </Box>
              </Grid>
            </Grid>
            {/* term & privacy */}
            <Grid container spacing={3} className={classes.box}>
              <Grid item xs={12} md={12}>
                <Box
                  className={classNames({
                    [classes.title]: true,
                    "mt-0": true,
                  })}
                >
                  <Typography variant="h5">
                    {t("title.term_and_privacy")}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} md={6} style={{ display: "inline-flex" }}>
                <Field
                  component={AppCheckbox}
                  id="confirmCollectInformation"
                  name="confirmCollectInformation"
                  style={{
                    width: "30px",
                  }}
                />
                <p>
                  <span>{t("text.subscribeMessage1")}</span>
                  <span className={classes.link}>{t("text.privacyPolcy")}</span>
                  <span>{t("text.subscribeMessage2")}</span>
                  <span className={classes.link}>{t("text.termOfUse")}</span>
                </p>
              </Grid>
            </Grid>
            <FormGroup className={classes.control}>
              <AppButton
                className="ml-3"
                label={`${t("button.subscribe")}`}
                rounder
                type="submit"
                isLoading={isLoading}
                disabled={!values.confirmCollectInformation || isLoading || isOpenEdit}
                onClick={handleSubmit}
              />
            </FormGroup>
          </Form>
        )}
      </Formik>
    </Box>
  );
};
const SubScriptionDetail = () => {
  return (
    <Elements stripe={stripePromise}>
      <SubscriptionDetail />
    </Elements>
  );
};
export default SubScriptionDetail;
